// Port of api/fuel/app/classes/filter/search/games/filters/query/comment/date.php
export default {
	name: 'comment.date',
	priority: 79,
	require: function(config, filter) {
		return filter.comment && (filter.comment.date.from || filter.comment.date.to)
	},
	run: function(config, filter, data, query) {
		if (filter.comment.date.from) query.where('m.comment_date', '>=', filter.comment.date.from)
		if (filter.comment.date.to) query.where('m.comment_date', '<=', filter.comment.date.to)
	}
}
